import React, { ReactNode } from 'react';

interface ChatLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
  sidebarCollapsed?: boolean;
}

const ChatLayout: React.FC<ChatLayoutProps> = ({
  sidebar,
  children,
  sidebarCollapsed = false
}) => {
  return (
    <div className="flex h-full w-full overflow-hidden">
      {/* Sidebar */}
      <div
        className={`
          ${sidebarCollapsed ? 'w-0' : 'w-64'}
          transition-all duration-300 ease-in-out
          border-r border-gray-200 bg-gray-50
          overflow-hidden
        `}
      >
        {sidebar}
      </div>

      {/* Main content */}
      <div className="flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default ChatLayout;
